import get from 'lodash/get';

export const getPersistValue = (state, path, defaultValue) =>
    get(state, ['persist', ...String(path).split('.')], defaultValue);
